/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitAccountResolutionsQueries
 */
export interface MonitAccountResolutionsQueries {
    /**
     * 
     * @type {number}
     * @memberof MonitAccountResolutionsQueries
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitAccountResolutionsQueries
     */
    page_size?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionsQueries
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionsQueries
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionsQueries
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionsQueries
     */
    datapoint?: string;
}

/**
 * Check if a given object implements the MonitAccountResolutionsQueries interface.
 */
export function instanceOfMonitAccountResolutionsQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitAccountResolutionsQueriesFromJSON(json: any): MonitAccountResolutionsQueries {
    return MonitAccountResolutionsQueriesFromJSONTyped(json, false);
}

export function MonitAccountResolutionsQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitAccountResolutionsQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
    };
}

export function MonitAccountResolutionsQueriesToJSON(value?: MonitAccountResolutionsQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'domain': value.domain,
        'asset': value.asset,
        'port': value.port,
        'datapoint': value.datapoint,
    };
}

